import { data } from '../../svg/MoreVert/data';
import { makeIcon } from '../makeIcon';

export const MoreVert = makeIcon(data, 'more_vert', 'MoreVert');

export default MoreVert;
